import { createFeatureSelector, createSelector } from '@ngrx/store';
import { authenticationFeatureKey, AuthenticationState } from './authentication.reducer';

export const getAuthenticationFeature = createFeatureSelector<AuthenticationState>(authenticationFeatureKey);

export const getToken = createSelector(getAuthenticationFeature, (state) => state.token);
export const getFullTokenLoaded = createSelector(getAuthenticationFeature, (state) => state.fullTokenLoaded);
export const getKioskSiteInit = createSelector(getAuthenticationFeature, (state) => state.kioskSiteInit);
